import Select from "react-select";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import { useAcompanhamentoMetas } from "./AcompanhamentoMetascontext";
import styles from "./AcompanhamentoMetas.module.scss";
import { api } from "../../../../services/api";
import { toast } from "react-toastify";
import { useMisc } from "../../../../contexts/MiscContext";

const ModalAcompanhamentoMetas = () => {
  const {
    showCad,
    listagem,
    handleCancel,
    dataProgramacao,
    setDataProgramacao,
    encarregado,
    setEncarregado,
    meta,
    setMeta,
    handleSearch,
  } = useAcompanhamentoMetas();

  const { setShowLoading } = useMisc();
 

  const handleInput = async () => {
          if (!dataProgramacao || !encarregado || !meta) {
              alert("Por favor, preencha todos os campos.");
              return;
          } 
          try {
              setShowLoading(true);
              const response = await api.post('/corte/controle-enfesto/acompanhamento-metas/acompanhamento-metas', {
                  dataProgramacao,
                  idEquipe: encarregado.value,
                  meta,
              });
  
              if (response.status === 200) {
                  toast.success("Dados enviados com sucesso!");
                  handleCancel();
                  handleSearch();
              } else {
                  toast.error("Erro ao enviar os dados.");
              }
          } catch (error) {
              toast.error("Erro ao enviar os dados.");
          } finally {
              setShowLoading(false);
          }
    }

  const customSelectStyles = {
    container: (provided) => ({
      ...provided,
      width: "100%",
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#dee2e6" : "#dee2e6",
      boxShadow: state.isFocused ? "0 0 0 1px #dee2e6" : "none",
      "&:hover": { borderColor: "#dee2e6" },
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    input: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
  };

  const handleEncarregado = (selectedOption) => {
    setEncarregado(selectedOption);
  };

  return (
    <Modal
      show={showCad}
      onHide={handleCancel}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>DEMANDA DIÁRIA</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Data Programação</Form.Label>
            <Form.Control
              type="date"
              value={dataProgramacao}
              onChange={(e) => setDataProgramacao(e.target.value)}
              min={new Date().toISOString().split("T")[0]}
            />
          </Form.Group>

          <Row className="mt-3">
            <Col>
              <Form.Label>EQUIPE</Form.Label>
              <Select
                options={listagem.equipe}
                placeholder="Selecione a equipe"
                styles={customSelectStyles}
                value={encarregado}
                onChange={handleEncarregado}
              />
            </Col>
            <Col>
              <Form.Label>META</Form.Label>
              <Form.Control
                type="number"
                placeholder="Digite a meta"
                className={styles.MetaTable}
                value={meta}
                onChange={(e) => setMeta(e.target.value)}
              />
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleInput}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAcompanhamentoMetas;